import { useCallback, useEffect, useState } from "react";
import api from "./api";

/**
 * Live-Status-Schema Loader (Feb 2026 · Struktur-Fix).
 *
 * Zieht die systemweite Master-Liste des „Objekte · Live-Status" von
 * `/api/live-status-schema` (Kunden-lesbar) oder `/api/team/live-status-schema`
 * (Team). Ergebnis: `{ items, loading, refresh }`.
 *
 * Jedes Schema-Item hat die Form:
 *   { key, label, icon, input_type, locked, placeholder?, hint? }
 *
 * `icon` ist ein Lucide-Icon-Name (String) — die Konsumenten müssen ihn
 * per `ICON_MAP` (siehe `lib/liveStatusIcons.js`) auf ein React-Component
 * mappen.
 */
export function useLiveStatusSchema({ team = false } = {}) {
  const [items, setItems] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const path = team ? "/team/live-status-schema" : "/live-status-schema";
      const { data } = await api.get(path);
      setItems(data.items || []);
    } catch (e) {
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [team]);

  useEffect(() => { load(); }, [load]);

  return { items: items || [], loading, refresh: load };
}
